import { ChainId, Currency, CurrencyAmount, Token, TokenAmount, WETH } from '../sdk'
import { getNativeCurrency, isNativeCurrency } from '../config/native'

export function wrappedCurrency(currency: Currency | undefined, chainId: ChainId | undefined): Token | undefined {
  if (!chainId || !currency) return undefined
  if (isNativeCurrency(currency, chainId)) return WETH[chainId]
  if (!(currency instanceof Token)) return WETH[chainId]
  return currency
}

export function wrappedCurrencyAmount(
  currencyAmount: CurrencyAmount | undefined,
  chainId: ChainId | undefined,
): TokenAmount | undefined {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : undefined
  return token && currencyAmount ? new TokenAmount(token, currencyAmount.raw) : undefined
}

export function unwrappedToken(token: Token): Currency {
  if (token.equals(WETH[token.chainId])) {
    return getNativeCurrency(token.chainId)
  }
  return token
}
